module.exports = __webpack_public_path__ + "img/reference-ae-projektmanagement.987724c6.webp";